import React from 'react';
import { Sparkles } from '@react-three/drei';

export default function NebulaField() {
  return (
    <>
      {/* 1. Steady Cyan/Teal Cosmic Dust */}
      <Sparkles
        count={200}
        scale={[140, 100, 260]}
        position={[0, 0, -30]}
        size={2.2}
        speed={0.15}
        opacity={0.35}
        color="#43DDD0"
      />

      {/* 2. Deep Blue-Violet Star Dust Layer */}
      <Sparkles
        count={160}
        scale={[160, 110, 260]}
        position={[0, 0, -40]}
        size={1.8}
        speed={0.12}
        opacity={0.3}
        color="#818cf8"
      />

      {/* 3. Golden Amber Soft Stellar Particles */}
      <Sparkles
        count={120}
        scale={[120, 80, 200]}
        position={[0, 0, -20]}
        size={1.6}
        speed={0.1}
        opacity={0.25}
        color="#fef08a"
      />
    </>
  );
}
